import { createApp } from 'vue'
import App from './App.vue'
import 'amfe-flexible'
//提升css超过router，尝试解决safari布局错乱问题
import './assets/styles/index.scss'

import router from './router/index'
import store from './store/index'

import 'dayjs/locale/zh-cn'
import plugins from './plugins/index'

// import 'core-js' //需要按需引入
import directives from './directive/index'

import { Tab, Tabs, Divider, Toast, Image, Collapse, CollapseItem } from 'vant'

const app = createApp(App)

// 注册全局ICON
app.use(router)
app.use(store)
app.use(plugins)
app.use(directives)
app.use(Tab)
app.use(Tabs)
app.use(Divider)
app.use(Toast)
app.use(Image)
app.use(Collapse)
app.use(CollapseItem)

app.mount('#app')
